import {
  FoldOptionLeft,
  FoldOptionRight,
  LeftFold,
  RightFold,
  TopFoldHeaderContainer,
} from '@/components/general/TopFold';
import FoldArrow from '../general/FoldArrow';

export type RewardsPossibleModes = 'Claim' | 'Confirm';

type Props = {
  mode: RewardsPossibleModes;
};

function RewardsTopFold({ mode }: Props) {
  return (
    <TopFoldHeaderContainer>
      <LeftFold>
        <FoldOptionLeft selected>Claim mevETH Rewards</FoldOptionLeft>
      </LeftFold>
      <RightFold>
        <FoldOptionRight disabled selected={mode === 'Claim'}>
          1. Claim
        </FoldOptionRight>
        <FoldArrow />
        <FoldOptionRight disabled selected={mode === 'Confirm'}>
          2. Confirm
        </FoldOptionRight>
      </RightFold>
    </TopFoldHeaderContainer>
  );
}

export default RewardsTopFold;
